/**
 * Flattens a row-major 2D array into a contiguous Float32Array without
 * creating an intermediate JS array (avoids the GC pressure of `.flat()`).
 */
export function flatten2DValues(
  values: ReadonlyArray<ReadonlyArray<number>>
): Float32Array {
  const flattened = new Float32Array(
    values.reduce((total, row) => total + row.length, 0)
  )
  let offset = 0

  for (const row of values) {
    flattened.set(row, offset)
    offset += row.length
  }

  return flattened
}
